{% block scop_platform_redirect_list %}
    <sw-page class="scop-platform-redirect-list">
        <template #smart-bar-actions>
            {% block scop_platform_redirect_list_smarbar %}
                <mt-button variant="primary" @click="$router.push({name: 'scop.platform.redirect.create'})">
                    {{ $t('scopplatformredirecter.list.createButton') }}
                </mt-button>
                <mt-button variant="secondary" @click="onClickExport" :isLoading="exportLoading" :disabled="noRedirect">
                    {{ $t('scopplatformredirecter.list.exportAllButton') }}
                </mt-button>
                <mt-button variant="secondary" @click="onClickImport">
                    {{ $t('scopplatformredirecter.list.importButton') }}
                </mt-button>
                <mt-button class="mt-external-link" variant="action" :link="$tc('scopplatformredirecter.list.faqButton.link')">
                    {{ $t('scopplatformredirecter.list.faqButton.text') }} <sw-icon name="regular-external-link" small="true"/>
                </mt-button>
            {% endblock %}
        </template>
        <template #content>
            {% block scop_platform_redirect_list_content %}
                <sw-entity-listing
                        ref="listing"
                        v-if="redirect"
                        :items="redirect"
                        :repository="repository"
                        :columns="columns"
                        detailRoute="scop.platform.redirect.details"
                        @update-records="onUpdate"
                        @inline-edit-save="onInlineEditSave"
                >
                    <template #column-queryParamsHandling="{ item }">
                        {{ $tc('scopplatformredirecter.list.queryParamsHandlingValues.' + item.queryParamsHandling) }}
                    </template>
                    <template #column-salesChannel="{ item }">
                        {{ item.salesChannel ? item.salesChannel.translated.name : $tc('scopplatformredirecter.list.allSalesChannels') }}
                    </template>
                </sw-entity-listing>
            {% endblock %}
            {% block scop_platform_redirect_list_view_import_modal %}
                <scop-platform-redirect-import-export-modal
                        :show="showImportExportModal"
                        :type="modalType"
                        @close="closeImportExport"
                        @updateList="updateList"
                >
                </scop-platform-redirect-import-export-modal>
            {% endblock %}
        </template>
    </sw-page>
{% endblock %}
